import {FiCheck, FiPlayCircle} from "react-icons/fi";
import React, {useState} from "react";
import {MediaAsset} from "../@types/AssetTypes.ts";
import { LazyLoadImage } from 'react-lazy-load-image-component';

export default function RenderMediaAsset({ isSelected,
    aspectRatio,
    item,
    hideLabel,
    sharpCorners,
    width, height=200}:{
    aspectRatio?: string,
    item: MediaAsset,
    hideLabel?: boolean,
    sharpCorners?: boolean,
    width?: number | string,
    height?: number | string,
    isSelected?: boolean,
}){
    const {thumbnail, mimetype, name, animationURL} = item;
    const [hovering, setHovering] = useState(false)
    return <div
        onMouseOver={animationURL ? ()=>setHovering(true) : undefined}
        onMouseOut={animationURL ? ()=>setHovering(false) : undefined}
        className={`overflow-hidden shadow ${sharpCorners ? '' : 'rounded'}`} style={{position:'relative', width: width || '100%', height, aspectRatio,}}>
        <LazyLoadImage alt={"Image thumbnail"}
             className={isSelected ? `` : null}
             src={hovering ? animationURL : thumbnail} style={{width:'100%', height:'100%', objectFit:'cover'}} />
        {
            !hovering && mimetype?.startsWith("video") ? <div className={"flex items-center justify-center inset-0 absolute"}>
                <FiPlayCircle className={"bg-light text-dark rounded-circle"} size={42} />
            </div> : null
        }
        {
            !hideLabel && name ?
            <small className={"ellipsis bg-success-subtle  px-2 py-1 position-absolute bottom-0 start-0 end-0"}>{name}</small> : null
        }

        {
            isSelected ? <span className={"absolute bg-primary text-black px-2 py-1 top-0 end-0"}><FiCheck size={20} /></span> : null
        }
    </div>
}
